<p-menubar [model]="items">
  <ng-template pTemplate="end">
    <ng-container *ngFor="let item of itemsRight">
        <a (click)="onLogout(item)"  class="p-menuitem-link">
            <span [class]="item.icon"></span>
            <span> {{ item.label }}</span>
        </a>
    </ng-container>
  </ng-template>
</p-menubar>
